import axios from "axios";
import { constants } from "../util/Constants";
let { host, host_admin,domain } = constants;
const crypto = require('crypto-js');


function aesEncrypt(data) {
  let ENC_KEY = process.env.REACT_APP_KEY; // set random encryption key
  let IV = process.env.REACT_APP_IV; // set random initialisation vector
  
  let cipher = crypto.AES.encrypt(data, ENC_KEY, {
      iv: IV,
      mode: crypto.mode.CBC,
      padding: crypto.pad.Pkcs7
  });
  return cipher.toString();
}



export let Createtranx = (state, setState, resp, setResp, redirect) => {
  let content = aesEncrypt(JSON.stringify(state));
  let data = {
    lob_id: state.payment_data.lob_id,
    payment_source_id: state.payment_data.payment_source_id,
    request_id: state.payment_data.request_id,
    request_date: state.payment_data.request_date,
    content: content
  };

  axios
    .post(`${host}/api/plorder/create`, data)
    .then((res) => {
      if (!res.data.success) {
        let ext = res.data.error.map((k) => k + "\n").join(",\n");
        return window.swal(ext, "", "error");
      }

      setResp(res.data);
      window.swal("Created", "", "success");

      if (redirect) {
        let url = res.data?.response?.links?.web_url;
        if (!url) return;

        try {
          const parsedUrl = new URL(url);
          const targetHost = parsedUrl.hostname.toLowerCase();
          const allowedDomain = domain.toLowerCase(); // "liuatpayments.adityabirlacapital.com"

          // ✅ Strict match: Only allow URLs that exactly match the allowed domain
          const isTrusted = targetHost === allowedDomain;

          if (isTrusted) {
            window.open(parsedUrl.href, "_blank", "noopener,noreferrer");
          } else {
            console.warn("Blocked redirect to untrusted domain:", parsedUrl.href);
            window.swal("Untrusted redirect blocked", "", "error");
          }
        } catch (e) {
          console.error("Invalid redirect URL:", url);
          window.swal("Invalid redirect URL", "", "error");
        }
      }
    })
    .catch((err) => {
      setResp(err);
      window.swal("", "", "error");
    });
};



export let getResult = (pl_order_id, state, setState, final) => {
  axios
    .get(`${host}/api/web/processJuspayResponse/${pl_order_id}`, {
      headers: {
        lob_id: window.location.pathname.split("/")[2],
        payment_source_id: window.location.pathname.split("/")[3],
      },
    })
    .then(function (response) {
      let data = response.data;
      setState(data);
    });
};

export let getAllNode = (lob_code, setState, trigger, setTrigger) => {
  axios
    .post(`${host_admin}/api/admin/master/sourcenode/all`, {
      lob_code: lob_code,
    })
    .then(function (response) {
      let data = response.data;
      setState(data);
    });
};

export let getAllField = (
  lob_code,
  payment_methods,
  setState,
  trigger,
  setTrigger
) => {
  axios
    .post(`${host_admin}/api/admin/master/sourcefield/all`, {
      lob_code: lob_code,
      payment_methods: payment_methods,
    })
    .then(function (response) {
      let data = response.data;
      setState(data);
      setTrigger(!trigger);
    });
};
